import { useMutation, useQueryClient } from "@tanstack/react-query";

import { clearSportsSuspensions } from "@/api/sportsNew";
import { SportsNewQueryKeys } from "@/tanstackQuery/queries/sportsNew";
import type {
  ClearSportSuspensionsParams,
  SportSuspensionsEditorResponse,
} from "@/types/ApiResponses/Sport";

export const useClearSportsSuspensions = (targetUsername?: string) => {
  const queryClient = useQueryClient();
  const queryKey = [SportsNewQueryKeys.SportsSuspensions, targetUsername];

  return useMutation({
    mutationFn: (params: ClearSportSuspensionsParams) =>
      clearSportsSuspensions(params),
    onMutate: async () => {
      await queryClient.cancelQueries({ queryKey, exact: true });

      const previousData =
        queryClient.getQueryData<SportSuspensionsEditorResponse>(queryKey);

      if (previousData) {
        queryClient.setQueryData<SportSuspensionsEditorResponse>(queryKey, {
          ...previousData,
          suspensions: {},
        });
      }

      return { previousData };
    },
    onError: (_err, _variable, context) => {
      if (context?.previousData) {
        queryClient.setQueryData(queryKey, context.previousData);
      }
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey, exact: true });
    },
  });
};
